import { render, staticRenderFns } from "./detailsAccounts.vue?vue&type=template&id=6202c18d"
import script from "./detailsAccounts.vue?vue&type=script&lang=js"
export * from "./detailsAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports